/** Client for the sk-hire v2 sourcing API (portals + CSV import). */
import axiosInstance from '../../api/axiosInstance';
import {
  HireMatch_Portals_Url,
  HireMatch_Portal_Connect_Url,
  HireMatch_Portal_Disconnect_Url,
  HireMatch_Imports_Url,
} from '../../api/endpoints';

export interface Portal {
  slug: string;
  displayName: string;
  status: 'connected' | 'disconnected';
  lastSyncAt: string | null;
  sourcedCount: number;
}

export interface ImportRow { name?: string; email?: string; consent?: boolean }

export interface ImportResult {
  id: string;
  sourceFileName: string;
  totalRows: number;
  importedCount: number;
  failedCount: number;
  failures: { row: number; reason: string }[];
  columnMapping: Record<string, string>;
  recordedAt: string;
}

export async function listPortals(): Promise<Portal[]> {
  const { data } = await axiosInstance.get<Portal[]>(HireMatch_Portals_Url);
  return Array.isArray(data) ? data : [];
}
export async function connectPortal(slug: string): Promise<Portal[]> {
  const { data } = await axiosInstance.post<Portal[]>(HireMatch_Portal_Connect_Url(slug));
  return data;
}
export async function disconnectPortal(slug: string): Promise<Portal[]> {
  const { data } = await axiosInstance.post<Portal[]>(HireMatch_Portal_Disconnect_Url(slug));
  return data;
}
export async function importCsv(
  sourceFileName: string, columnMapping: Record<string, string>, rows: ImportRow[],
): Promise<ImportResult> {
  const { data } = await axiosInstance.post<ImportResult>(HireMatch_Imports_Url, { sourceFileName, columnMapping, rows });
  return data;
}
